export enum CMS_ITEM_NAME {
  DYNAMIC_STATISTICS = 'dynamic-statistics',
  FEATURED_SHOP = 'featuredShop',
  PRODUCT_CAMPAIGNS = 'productCampaigns',
  FEATURED_LINKS = 'featuredLinks',
  CATEGORIES = 'categories',
  BRANDS = 'brands',
  HOMEPAGE_PRODUCTS = 'homepageProducts',
  BANNER_MAIN = 'banner-main',
}
